/* BAKERLY_PDP_SALE_BADGE_V5 */
(function () {
  function selectedVariant(root, variants) {
    var field = root.querySelector('input[name="id"], select[name="id"]');
    var selectedId = field && field.value;
    return variants.find(function (variant) {
      return String(variant.id) === String(selectedId);
    }) || variants[0];
  }

  function renderBadge(root, variant) {
    var priceNode = root.querySelector(
      '.product-price-container > .no-js-hidden > span.price'
    );
    if (!priceNode || !variant) return;

    var priceContainer = priceNode.closest('.product-price-container');
    var priceWrapper = priceNode.parentElement;
    if (!priceContainer || !priceWrapper) return;

    priceNode.querySelectorAll('.badge.onsale').forEach(function (badge) {
      var group = badge.closest('.badges');
      badge.remove();
      if (group && !group.children.length) group.remove();
    });

    var stableGroups = Array.from(
      priceContainer.querySelectorAll('.bakerly-sale-badges-v5')
    );
    var badgeGroup = stableGroups.shift() || null;

    stableGroups.forEach(function (duplicate) {
      duplicate.remove();
    });

    var price = Number(variant.price || 0);
    var compareAt = Number(variant.compareAtPrice || 0);

    if (compareAt <= price) {
      if (badgeGroup) badgeGroup.remove();
      return;
    }

    if (!badgeGroup) {
      badgeGroup = document.createElement('span');
      badgeGroup.className = 'badges bakerly-sale-badges-v5';
    }

    if (badgeGroup.parentElement !== priceContainer) {
      priceWrapper.insertAdjacentElement('afterend', badgeGroup);
    }

    var saleBadge = badgeGroup.querySelector('.badge.onsale');
    if (!saleBadge) {
      saleBadge = document.createElement('span');
      saleBadge.className = 'badge onsale bakerly-sale-badge-v5';
      badgeGroup.appendChild(saleBadge);
    }

    var percentage = Math.round((compareAt - price) * 100 / compareAt);
    var badgeText = 'Save ' + percentage + '%';
    if (saleBadge.textContent.trim() !== badgeText) {
      saleBadge.textContent = badgeText;
    }
  }

  function syncStickyCta(root) {
    var mainButton = root.querySelector(
      '.product-form button[type="submit"][name="add"]:not(#AddToCartSticky)'
    );
    var mainLabel = mainButton && mainButton.querySelector(
      '.bakerly-cta-label-v4'
    );
    var sticky = document.getElementById('AddToCartSticky');

    if (!mainButton || !mainLabel || !sticky) return;

    sticky.classList.add('bakerly-sticky-overlay-active-v8');

    var overlay = sticky.querySelector(
      ':scope > .bakerly-sticky-cta-overlay-v8'
    );
    if (!overlay) {
      overlay = document.createElement('span');
      overlay.className = 'bakerly-sticky-cta-overlay-v8';
      sticky.appendChild(overlay);
    }

    var key = mainLabel.getAttribute('data-price-key') || '';
    var overlayLabel = overlay.querySelector('.bakerly-cta-label-v4');

    if (
      !overlayLabel ||
      overlay.getAttribute('data-price-key') !== key ||
      overlayLabel.textContent !== mainLabel.textContent
    ) {
      overlay.replaceChildren(mainLabel.cloneNode(true));
      overlay.setAttribute('data-price-key', key);
    }

    sticky.setAttribute(
      'aria-label',
      mainButton.getAttribute('aria-label') || 'Add to cart'
    );
  }

  function refresh() {
    document.querySelectorAll('.bakerly-sale-badge-data-v5').forEach(function (dataNode) {
      var root = dataNode.closest('.product-information--inner');
      if (!root) return;

      var variants;
      try {
        variants = JSON.parse(dataNode.textContent);
      } catch (error) {
        return;
      }

      renderBadge(root, selectedVariant(root, variants));
      syncStickyCta(root);
    });
  }

  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 20);
  }

  window.BakerlySaleBadgeV5 = { schedule: schedule };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  document.addEventListener('change', schedule, true);
  document.addEventListener('click', schedule, true);
  document.addEventListener('product:variant-change', schedule);
  document.addEventListener('shopify:section:load', schedule);

  new MutationObserver(schedule).observe(document.body, {
    attributes: true,
    attributeFilter: ['class', 'checked', 'value'],
    childList: true,
    subtree: true
  });
})();
